import { MolsonDxGrid } from '@components/reusable'
import { molsonStyled } from '@theme'

export const BannerCompatibleGrid = molsonStyled(MolsonDxGrid)(({ theme }) => ({
  '& .dx-datagrid-header-panel': {
    backgroundColor: theme.palette.secondary[50]
  },
  '& .dx-datagrid-headers': {
    marginTop: '-12px'
  },
  '& .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused):not(.dx-row-removed) > td':
    {
      backgroundColor: theme.palette.primary.lightest,
      color: 'unset'
    },
  '& .dx-toolbar .dx-toolbar-items-container': {
    backgroundColor: theme.palette.secondary[50]
  }
}))
